import { useGcsStore } from '../../store/useGcsStore';
import { selectIsVehicleSimulated } from '../../store/selectors/selectIsVehicleSimulated';
import type { VehicleId } from '../../types/gcs/vehicle';
import { en } from '../../locales/en';
import { Text } from './Text';

interface VehicleSimulationIndicatorProps {
  gcsId: string;
  vehicleId: VehicleId;
}

export const VehicleSimulationIndicator = ({ gcsId, vehicleId }: VehicleSimulationIndicatorProps) => {
  const isSimulated = useGcsStore((state) => selectIsVehicleSimulated(state.data, gcsId, vehicleId));

  if (!isSimulated) {
    return null;
  }

  return (
    <div
      title={en.simulationIndicator.title}
      style={{
        width: 20,
        height: 20,
        borderRadius: '50%',
        backgroundColor: '#CDCDCD',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }}
    >
      <Text variant='body3-bold' style={{ color: '#434343' }}>
        {en.simulationIndicator.label}
      </Text>
    </div>
  );
};
